<section>
    <!-- <div class="container"> -->
        <div class="row">
            <div class="col-lg-12 mt-4 mb-5">
                <div class="cctvcouncelling__sec">
                    <div class="councellist__flex">
                        <div class="counceltitle__flex">
                            <div>
                                <h5 class="councel__name">Student Wi-fi Setup</h5>


                            </div>
                            <div>
                                <h5 class="councel__name">Selected: {{selectedItems.length}}</h5>
                            </div>
                        </div>
                        <div>
                            <form [formGroup]="myForm">
                                <div class="wifi-list d-flex align-center pt-2">
                                    <mat-form-field class="col-md-4">
                                        <mat-label>State</mat-label>
                                        <mat-select name="state" formControlName="state"
                                            (click)="stateinput(matSelect)">
                                            <input class="input_border" type="text" placeholder="State Search"
                                                [formControl]="statename">
                                            <mat-option [value]="state.stateName"
                                                *ngFor="let state of stateOptions |async" (click)="getcity(state)"
                                                (click)="clearcity()">{{state.stateName}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field class="col-md-4">
                                        <mat-label>City</mat-label>
                                        <mat-select name="city" formControlName="city" (click)="cityinput(matSelect)">
                                            <input type="text" class="input_border" placeholder="City Search"
                                                name="state" [formControl]="cityname">
                                            <mat-option *ngFor="let city of cityoption |async" [value]="city.cityName"
                                                (click)="getcampus(city)" (click)="clearcampus()">{{city.cityName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field class="col-md-4">
                                        <mat-label>Campus</mat-label>
                                        <mat-select name="camp" formControlName="campus"
                                            (click)="campusinput(matSelect)">
                                            <input type="text" class="input_border" placeholder="Campus Search"
                                                name="state" [formControl]="campusname">
                                            <mat-option *ngFor="let camp of campusoption |async "
                                                [value]="camp.campusName" (click)="getbuliding(camp)"
                                                (click)="clearbuliding()">{{camp.campusName}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                </div>
                                <div class="wifi-list d-flex align-center">

                                    <mat-form-field class="col-md-8">
                                        <mat-label>Building</mat-label>
                                        <mat-select name="buil" formControlName="building"
                                            (click)="buildinginput(matSelect)">
                                            <input type="text" class="input_border" placeholder="Building Search"
                                                name="state" [formControl]="buildingnames">
                                            <mat-option *ngFor="let buil of buildingoption |async"
                                                [value]="buil.buildingName" (click)="getwifilist(buil)"
                                                (click)="clearwifi()">{{buil.buildingName}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>


                                    <mat-form-field class="col-md-4">
                                        <mat-label>Wi-Fi Name</mat-label>
                                        <mat-select name="wifi" formControlName="wifi" (click)="wifiinput(matSelect)">
                                            <input type="text" class="input_border" placeholder="search" name="state"
                                                [formControl]="wifinames">
                                            <mat-option *ngFor="let wifi of wifioption | async" [value]="wifi.ssidName"
                                                (click)="gettable(wifi)"
                                                (click)="cleartable()">{{wifi.ssidName}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </form>
                        </div>

                        <!-- <div class="border-line"></div> -->
                        <div class="ibox-content">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped cctv_datatable" id="studenttables">
                                    <thead>
                                        <tr *ngFor="let item of headdata">
                                            <th>
                                                <input type="checkbox" id="selectAll" class="main"
                                                    (change)="toggleSelectAll($event)" (change)="event('change')">
                                            </th>
                                            <th>{{item.admNo}}</th>
                                            <th>{{item.studentName}}</th>
                                            <th>{{item.dob}}</th>
                                            <th>{{item.className}}</th>
                                            <th>{{item.section}}</th>
                                            <th>{{item.programName}}</th>
                                            <th>{{item.examProgram}}</th>
                                            <th>{{item.view}}</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container>
                                            <tr *ngFor="let data of table">
                                                <td>
                                                    <input type="checkbox" class="childselect"
                                                        [checked]="selectAllChecked" (click)="studentSelect(data)">
                                                </td>
                                                <td style="font-family: montserrat,sans-serif;">{{data.admNo}}</td>
                                                <td style="font-family: montserrat,sans-serif;">{{data.studentName}}
                                                </td>
                                                <td style="font-family: montserrat,sans-serif;">{{data.dob}}</td>
                                                <td style="font-family: montserrat,sans-serif;">{{data.className}}</td>
                                                <td style="font-family: montserrat,sans-serif;">{{data.section}} </td>
                                                <td style="font-family: montserrat,sans-serif;">{{data.programName}}
                                                </td>
                                                <td style="font-family: montserrat,sans-serif;">{{data.examProgram}}
                                                </td>
                                                <td><button type="button" class="cctv_btnview" (click)="studentwifi(data)">view</button></td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-lg-12 text-center">
                            <button type="button" class="cctv_notebtn" (click)="onSubmit()">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <!-- </div> -->
</section>

<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>